"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoSection = InfoSection;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Language = _interopRequireDefault(require("@material-ui/icons/Language"));

var _EmailOutlined = _interopRequireDefault(require("@material-ui/icons/EmailOutlined"));

var _PhoneOutlined = _interopRequireDefault(require("@material-ui/icons/PhoneOutlined"));

function InfoItem(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      _ref$truncate = _ref.truncate,
      truncate = _ref$truncate === void 0 ? true : _ref$truncate;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline py-2 text-sm text-dark"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-4"
  }, /*#__PURE__*/_react["default"].createElement(icon, {
    className: '!text-sm'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      truncate: truncate,
      'break-all': !truncate
    })
  }, children));
}

function InfoSection(_ref2) {
  var title = _ref2.title,
      children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "my-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm font-light uppercase text-light"
  }, title), children);
}

var _default = function _default(_ref3) {
  var contact = _ref3.contact;
  var emails = contact.emails,
      phones = contact.phones,
      websites = contact.websites;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-4 px-6"
  }, emails.length > 0 && /*#__PURE__*/_react["default"].createElement(InfoSection, {
    title: "Email"
  }, emails.map(function (_ref4) {
    var email = _ref4.email;
    return /*#__PURE__*/_react["default"].createElement(InfoItem, {
      icon: _EmailOutlined["default"],
      key: email,
      truncate: false
    }, email);
  })), phones.length > 0 && /*#__PURE__*/_react["default"].createElement(InfoSection, {
    title: "Phone"
  }, phones.map(function (_ref5) {
    var phone = _ref5.phone;
    return /*#__PURE__*/_react["default"].createElement(InfoItem, {
      icon: _PhoneOutlined["default"],
      key: phone
    }, phone);
  })), websites.length > 0 && /*#__PURE__*/_react["default"].createElement(InfoSection, {
    title: "Web Links"
  }, websites.map(function (_ref6) {
    var website = _ref6.website;
    return /*#__PURE__*/_react["default"].createElement(InfoItem, {
      icon: _Language["default"],
      key: website
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: "text-primary",
      href: formatLink(website),
      target: "__blank"
    }, website));
  })));
};

exports["default"] = _default;

function formatLink(link) {
  if (/^http(s)?:\/\//.test(link)) return link;else return "http://".concat(link);
}
//# sourceMappingURL=InfoView.js.map